const COMPANIES_TABLE_READY = "companies-table-ready"
const SEARCH_TEXT_STATE = "companies-table-search-text-state"
const ROWS_PER_PAGE_STATE = "companies-table-rows-per-page-state"
const PAGINATION_STATE = "companies-table-pagination-state"

const CITY_FILTER_STATE = "companies-table-city-filter-state"
const STATE_FILTER_STATE = "companies-table-state-filter-state"
const COMPANY_ID_FOR_ACTION = "companies-table-company-id-for-action"


const initialState = {
    isCompaniesTableReady: true,
    companies: {},

    previousCity: 0,
    previousState: 0,

    companySelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case COMPANIES_TABLE_READY:
            return Object.assign({}, state, { isCompaniesTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        
        case CITY_FILTER_STATE:
            return Object.assign({}, state, {previousCity:action.payload})

        case STATE_FILTER_STATE:
            return Object.assign({}, state, {previousState:action.payload})

        case COMPANY_ID_FOR_ACTION:
            return Object.assign({}, state, {companySelectedId:action.payload})

        default:
        return state
    
    }

}

export function companyTableReady(data) {
    return {
        type: COMPANIES_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function cityFilterState(city){
    return{
        type:CITY_FILTER_STATE,
        payload:city
    }
}

export function stateFilterState(state){
    return{
        type:STATE_FILTER_STATE,
        payload:state
    }
}

export function companyIdForAction(companyId){
    return{
        type:COMPANY_ID_FOR_ACTION,
        payload:companyId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Companies/redux/companies.js